import React from 'react'
import '../../src/pages/gruposTrabalho/grupos.css'

export default class Progresso extends React.Component{

  render() {
    return(
      <div className={this.props.classeTerciaria}>
        <br/>
        <div>
            Carregando Arquivo...
        </div>
      </div>
    );
  }
}